import images from "./image.json"
import Slides from "./Slides"
import i18n from "../../../../i18nextInitiator"

import {Swiper, SwiperSlide} from "swiper/react"
import SwiperCore, {Pagination, Navigation, Thumbs, Autoplay} from "swiper/core"

import "swiper/swiper.min.css"
import "swiper/swiper-bundle.css"
import "swiper/components/pagination/pagination.min.css"
import "swiper/components/navigation/navigation.min.css"
import "swiper/components/thumbs/thumbs.min.css"
import {Box, makeStyles, useMediaQuery} from "@material-ui/core"

SwiperCore.use([Pagination, Navigation, Thumbs, Autoplay])

const useStyles = makeStyles({
	root: {
		padding: 0,
		maxWidth: 600,
		overflow: "hidden",
		marginTop:32
	},
	swiperContainer: {
		width: "100%",
		margin: "0 auto",
	},
})
const t = i18n.getFixedT("fa", "general")

const InfoSlider = () => {
	const classes = useStyles()
	const {addresses} = images
	const {insure, price, service, support} = addresses

	const matches = useMediaQuery("(min-width:650px)")

	return (
		<Box className={classes.root}>
			<Swiper
				delay
				slidesPerView={1}
				navigation={matches}
				autoplay={{
					delay: 2500,
					disableOnInteraction: true,
				}}
				className={`mainSwiper ${classes.swiperContainer}`}>
				<SwiperSlide>
					<Slides
						title={t("appInfo.supportTitle")}
						text={t("appInfo.support")}
						image={support}
					/>
				</SwiperSlide>
				<SwiperSlide>
					<Slides
						title={t("appInfo.serviceTitle")}
						text={t("appInfo.service")}
						image={service}
					/>
				</SwiperSlide>
				<SwiperSlide>
					<Slides
						title={t("appInfo.priceTitle")}
						text={t("appInfo.price")}
						image={price}
					/>
				</SwiperSlide>
				<SwiperSlide>
					<Slides
						title={t("appInfo.insureTitle")}
						text={t("appInfo.insure")}
						image={insure}
					/>
				</SwiperSlide>
			</Swiper>
		</Box>
	)
}

export default InfoSlider
